<template>
  <div>
    <base-header
        class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center bg-gradient-primary"
        style="
        min-height: 200px;
        background-size: cover;
        background-position: center top;
      "
    >
      <!-- Mask -->
      <span class="mask bg-gradient-blue opacity-8"></span>
      <!-- Header container -->
      <div class="">
        <div class="row">
          <div class="col-12 text-start">
            <h3 class="text-white float-start pe-3">
              {{ employeeData.firstName }} {{ employeeData.lastName }}
            </h3>
            <div class="badge p-1 font-size-xs float-start" :class="getStatusClass(employeeData.status)">
              <span class="status">{{ $t(employeeData.status ?? "") }}</span>
            </div>
            <!--            <p class="text-white mt-0 mb-5">-->
            <!--              This is your profile page. You can see the progress you've made-->
            <!--              with your work and manage your projects or assigned tasks-->
            <!--            </p>-->
            <!--            <a href="#!" class="btn btn-info">Edit profile</a>-->
          </div>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--7">
      <router-view :employee-data="employeeData"></router-view>
    </div>
  </div>
</template>

<script>
import {getStatusClass} from "@/helpers/common"
export default {
  name: "EmployeeProfile",
  components: {},
  data() {
    return {
      employeeData: {}
    }
  },
  mounted() {
    // var self = this;
    this.employeeId = this.$store.state.user.claims.user_id
    this.getEmployee()
    this.getEmployeePrivateInfo()
  },
  methods: {
    getStatusClass,
    async getEmployee() {
      let self = this
      await this.$store
          .dispatch("fetchEmployee", this.employeeId)
          .then((data) => {
            // console.log("data", data)
            self.employeeData = data
          })
    },
    async getEmployeePrivateInfo(){
      let res = await this.$store.dispatch("fetchEmployeePrivateInfo", this.employeeId)
      // console.log("res", res )
      this.address = res.address
      this.employeeData.lang = res.hasOwnProperty("lang") ? res.lang : ""
      this.employeeData.email = res.email
      this.employeeData.iban = res.iban
      this.employeeData.bankName = res.bankName
      this.employeeData.tiNumber = res.tiNumber
      this.employeeData.registrationNumber = res.hasOwnProperty("registrationNumber") ? res.registrationNumber : ""
      this.employeeData.idCard = res.hasOwnProperty("idCard") ? res.idCard : ""

      this.employeeData.phoneNumber = res.phoneNumber
      if (res.hasOwnProperty("address")){
        this.employeeData.address = res.address
      }
    },
  },
}
</script>

<style scoped>

</style>